import React from 'react';
import Civil from './civil';

const MainCourse: React.FunctionComponent = () => <Civil />;

export default MainCourse;
